import { type PrimitiveProps } from '@react-three/fiber';
import { type EaselModel, GLTFModel } from '@billykwok/3d';

import { AnimatedPrimitive } from '@/utils/react-three-fiber/animations';
import { useGLTF } from '@/utils/react-three-fiber/useGLTF';

const modelPath = `/models/${GLTFModel.Easel}`;

export function AnimatedEasel(props: Partial<PrimitiveProps>) {
  const { scene } = useGLTF<EaselModel, string>(modelPath);
  return <AnimatedPrimitive object={scene} dispose={null} {...props} />;
}

useGLTF.preload(modelPath);
